export const reorderArray = <T,>(items: T[], fromIndex: number, toIndex: number): T[] => {
  const next = [...items];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
};

export const getPendingZeitraumDateError = (z: { startdatum: string; enddatum: string }) => {
  if (z.startdatum && z.enddatum && z.enddatum < z.startdatum) {
    return 'Enddatum darf nicht vor dem Startdatum liegen';
  }
  return '';
};

export const getStatusColor = (statusName?: string): string => {
  switch (statusName) {
    case 'Geprueft':
      return '#4caf50';
    case 'Review erbeten':
      return '#ff9800';
    case 'Abgelehnt':
      return '#b71c1c';
    case 'Entwurf':
    default:
      return '#2196f3';
  }
};
